export default [
  {
    type: 'bar',
  },
  {
    type: 'bar',
  },
  {
    type: 'bar',
  },
  {
    type: 'line',
  }
]